import { render, staticRenderFns } from "./ValidacionAseguradora.vue?vue&type=template&id=28301ce2&scoped=true"
import script from "./ValidacionAseguradora.vue?vue&type=script&lang=ts"
export * from "./ValidacionAseguradora.vue?vue&type=script&lang=ts"
import style0 from "./ValidacionAseguradora.vue?vue&type=style&index=0&id=28301ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28301ce2",
  null
  
)

export default component.exports